module.exports = __webpack_public_path__ + "804e4a290b9c7f3bd3017543bfc59dc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/developpement/architecture_de_linformatique.jpg
// module id = 163
// module chunks = 0